angular.module('app').controller('PaymentCtrl', function($rootScope, $http, $window, $mdToast, $scope, $mdDialog) {
    "ngInject";

    var main = this;
    main.paymentType = 'Credit Card';
    main.minPayment = '0.01';
    if(main.item.balance_due > 0) {
        main.total = main.item.balance_due;
    } else {
        main.total = main.item.total;
    }

    var startYear = new Date().getFullYear();
    main.years = [];
    for(var i=0; i<11; i++) {
        main.years.push(startYear+i);
    }

    main.credit = {};

    main.chooseCredit = function() {
        if(main.credit) {
            main.total = Math.min((main.credit.total - main.credit.total_used), main.total);
        }
    };

    main.updatePaymentType = function() {
        if(main.paymentType == 'Credit Card') {
            main.minPayment = '0.01';
        } else {
            main.minPayment = false;
        }
    };

    main.processPayment = function(payment) {
        main.item.payment = payment;
        main.item.payment_total = main.total;

        $http.post('/api/v1/admin/orders/' + main.item.id + '/payment', main.item).then(
            function(response) {
                main.item.payments.push(response.data);
                var alert = $mdToast.simple().textContent("Added payment");
                $mdToast.show(alert);
                $mdDialog.hide();
                main.paying = false;
            },
            function(response) {
                main.paying = false;
                delete main.item.payment;
            }
        );
    };

    var activeFranchiseId = $rootScope.franchiseSwitcher.activeFranchise();
    main.credits = main.item.user.credits.filter(function(credit) {
        if(credit.franchise != activeFranchiseId) {
            return false;
        }

        if(credit.total <= credit.total_used) {
            return false;
        }

        return true;
    });

   main.handleAcceptJSResponse = function(response) {
        if(response.messages.resultCode == 'Ok') {
            main.processPayment(response.opaqueData);
        } else {
            main.paying = false;
            var alert = $mdToast.simple().textContent(response.messages.message[0].text);
            $mdToast.show(alert);
        }
        $scope.$apply();
    };

    main.saveNonCC = function() {
        var data = {
            'type': main.paymentType,
            'total': main.total,
            'notes': main.notes,
            'credit_id': main.credit.id || null
        };
        $http.post('/api/v1/admin/orders/' + main.item.id + '/payment', data).then(
            function(response) {
                main.item.payments.push(response.data);
                var alert = $mdToast.simple().textContent("Added payment");
                $mdToast.show(alert);
                $mdDialog.hide();
                main.paying = false;
            },
            function(response) {
                main.paying = false;
            }
        );
    };

    main.save = function() {
        if(main.paying) {
            var alert = $mdToast.simple().textContent("Payment already in progress");
            $mdToast.show(alert);
            return;
        }

        main.paying = true;
        if(main.paymentType != 'Credit Card') {
            main.saveNonCC();
            return;
        }

        var authData = {};
        $http.get('/api/v1/admin/franchise/' + $rootScope.franchise_id).then(
            function(response) {
                authData.clientKey = response.data.auth_net_client_key;
                authData.apiLoginID = response.data.auth_net_login_id;

                cardData = {
                    'fullName': main.item.billing_address.first_name + " " + main.item.billing_address.last_name,
                    'zip': main.item.billing_address.zip,
                    'cardNumber': main.cc,
                    'cardCode': main.cvc,
                    'month': main.expMonth,
                    'year': main.expYear
                };
                console.log(cardData, authData);

                Accept.dispatchData(
                    { 'cardData': cardData, 'authData': authData },
                    main.handleAcceptJSResponse
                );
            },
            function(response) {
                main.paying = false;
            }
        );
    };
});
